import type { BoardScore, ScreenerEvent } from './boardTypes';
import type { SideLabels } from '../utils/boardOutcomeLabels';

export type NetSide = 'YES' | 'NO';

export function netCapital(score: BoardScore): number {
    return score.capital_usd_yes - score.capital_usd_no;
}

export function netSide(score: BoardScore): NetSide | null {
    const net = netCapital(score);
    if (net > 0) return 'YES';
    if (net < 0) return 'NO';
    return null;
}

export function leadScore(scores: readonly BoardScore[]): BoardScore | null {
    let best: BoardScore | null = null;
    for (const s of scores) {
        if (!best || Math.abs(netCapital(s)) > Math.abs(netCapital(best))) {
            best = s;
        }
    }
    return best;
}

export const BALANCED_LABEL = 'balanced';

export function positionLabel(
    event: Pick<ScreenerEvent, 'markets'> | null | undefined,
    score: BoardScore,
    labels: SideLabels
): string {
    const side = netSide(score);
    if (!side) return BALANCED_LABEL;
    const sideText = (side === 'NO' ? labels.no : labels.yes).text;
    const markets = event?.markets ?? [];
    if (markets.length <= 1) return sideText;
    const market = markets.find(m => m.market_id === score.market_id);
    const name = market?.outcome_yes_label ?? score.outcome_yes_label ?? null;
    if (!name || name.trim().toUpperCase() === sideText.toUpperCase()) {
        return sideText;
    }
    return `${sideText} · ${name}`;
}
